import React from 'react';
import { useShowContext } from 'framework/show';

interface LeaveColumnLayoutProps {
  children?: React.ReactNode | ((data: any) => React.ReactNode);
  label?: string;
  width?: number;
  size?: number | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
}

const LeaveColumnLayout: React.FC<LeaveColumnLayoutProps> = ({ children, size, ...props }) => {
  const { data } = useShowContext();

  return <div className="balances-leaves-column">{typeof children === 'function' ? children(data) : children}</div>;
};

export default LeaveColumnLayout;
